import { gql } from "@apollo/client";

export const UPLOAD_PUBLIC_MEDIA_AS_ADMIN = gql`
  mutation UploadPublicMediaAsAdmin($mediaInput: MediaInput!) {
    uploadPublicMediaAsAdmin(mediaInput: $mediaInput)
  }
`;
